import { useState as o, useLayoutEffect as r } from "react";
import { a as s } from "./isClient-ec947a14.mjs";
import { u } from "./useSlots-a1aa6a84.mjs";
function i() {
  return s ? { width: window.innerWidth, height: window.innerHeight } : { width: 0, height: 0 };
}
const a = () => {
  const [t, n] = o(i()), e = () => n(i());
  return u("resize", e), r(() => e(), []), t;
};
export {
  a as u
};
